import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { useQuery } from "@apollo/client";
import { BEAUTIFUL_PHONES_QUERY } from "Services/queries";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { LimitTariffsFromOperator } from "Constants/Limit";
import TagButtonComponent from "Containers/TagButtonComponent";
import BeautifulNumbersRow from "Containers/BeautifulNumbersRow";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";
import BeautifulNumbersWrapper from "ComponentsUI/BeautifulNumbers/BeautifulNumbersWrapper";
import { ShowMoreButton } from "ComponentsUI/Buttons";
import { OfferBlock } from "ComponentsUI/InfoBlocks";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import { NoTariffsInfo } from "ComponentsUI/InfoBlocks";
import { StubOperatorTariffs } from "ComponentsUI/Stub";
import { OPERATOR_TAB_BEAUTIFUL_NUMBERS } from "stores/OperatorModel";
import { createUseStyles } from "react-jss";
import { useGetBeautyTagsQuery } from "./hooks";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { isMainSiteCode } from "Utils/siteConfig";

const useStyles = createUseStyles((theme) => ({
	[`@media (min-width: ${theme.media.md})`]: {
		container: {
			marginTop: "50px",
		},
	},
}));

const BeautifulNumbers = (props) => {
	useEffect(() => {
		const {
			ApplicationModel: { operatorModel },
		} = props;
		if (operatorModel.visibleTab !== OPERATOR_TAB_BEAUTIFUL_NUMBERS) {
			operatorModel.changeTab(OPERATOR_TAB_BEAUTIFUL_NUMBERS);
		}
	}, []);

	let {
		ApplicationModel: {
			windowSizeModel: { windowSizes },
			text,
		},
		match: { params },
	} = props;
	const match = useWithDefaultParams();
	let regionUrl = match.params.regionUrl;
	const siteCode = props.ApplicationModel.siteCode;

	useEffect(() => {
		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.OPEN_NOMERA_OPERATOR, []);
	}, [params.tagCode]);

	const classes = useStyles();

	// Запрос на полчение всех доступных тегов
	const { isLoading: isMobileTagsLoading, mobileTags } = useGetBeautyTagsQuery();

	const filter = [];
	if (regionUrl) {
		filter.push(`provider.region.url=${regionUrl}`);
	}

	if (params.tagCode) {
		filter.push(`tags.translit=${params.tagCode}`);
	}

	if (params.operator) {
		filter.push(`provider.url_name=${params.operator}`);
	}

	// Запрос на получение всех номеров
	const beautifulPhonesQuery = useQuery(BEAUTIFUL_PHONES_QUERY, {
		variables: {
			filter: filter.join("&"),
			limit: LimitTariffsFromOperator,
			providerJoin: true,
		},
		notifyOnNetworkStatusChange: true,
	});

	// Если данные грузяться, то выводим стаб
	if (isMobileTagsLoading || beautifulPhonesQuery.loading) {
		return <StubOperatorTariffs />;
	}

	let beautifulPhones = beautifulPhonesQuery?.data?.beautifulPhones?.data;

	// Дозагрузка номеров
	const fetchMorePhones = () => {
		beautifulPhonesQuery.fetchMore({
			variables: {
				offset: beautifulPhonesQuery.data.beautifulPhones.data.length,
			},
			updateQuery: (prev, { fetchMoreResult }) => {
				if (!fetchMoreResult) return prev;

				return Object.assign({}, prev, {
					beautifulPhones: {
						...prev.beautifulPhones,
						data: [...prev.beautifulPhones.data, ...fetchMoreResult.beautifulPhones.data],
					},
				});
			},
		});
	};

	return (
		<PaddingTop containerClass={classes.container}>
			<PaddingBottom>
				<Container>
					{isMainSiteCode(siteCode) && <div></div>}
					{!!beautifulPhones && !!beautifulPhones.length && <OfferBlock text={text} />}
					<TagButtonComponent
						mobileTags={mobileTags}
						tagCode={params.tagCode}
						operatorBeautifulNumbers={true}
						operatorStyle={true}
					/>
					{(!beautifulPhones || !beautifulPhones.length) && (
						<EmptyStubWrapper
							headerText={text.NO_PHONE_TARIFFS_HEADER}
							displayText={<NoTariffsInfo text={text} beautifulNumber={true} />}
							buttonText={text.TO_MAIN_PAGE}
							iconHeader={"icon-balance"}
							iconButton={"icon-playlist-add"}
						/>
					)}
					{!!beautifulPhones && !!beautifulPhones.length && (
						<Row>
							<BeautifulNumbersWrapper>
								{beautifulPhonesQuery.data.beautifulPhones.data.map((item, index) => {
									return <BeautifulNumbersRow tariff={item} key={index} />;
								})}
							</BeautifulNumbersWrapper>
						</Row>
					)}
					{beautifulPhonesQuery?.data?.beautifulPhones?.data?.length <
						beautifulPhonesQuery?.data?.beautifulPhones?.pagination?.items_total && (
						<ShowMoreButton
							disabled={beautifulPhonesQuery.loading}
							windowSizes={windowSizes}
							text={text}
							onClickHandler={fetchMorePhones}
						/>
					)}
				</Container>
			</PaddingBottom>
		</PaddingTop>
	);
};

export default withRouter(inject("ApplicationModel")(BeautifulNumbers));
